module.exports = __webpack_public_path__ + "img/google_takeout_email.0e39d736.jpg";